import { render } from "./TransactionDiscount.vue?vue&type=template&id=43a65ae5"
import script from "./TransactionDiscount.vue?vue&type=script&lang=js"
export * from "./TransactionDiscount.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__